import {ErrorBoundary} from 'react-error-boundary'

import errorDecorSvg from '@/assets/images/error-page-decorator.svg'
import PrimaryButton from '@/components/PrimaryButton/PrimaryButton'
import Navbar from '@/layout/Navbar'
import HeadTags from '@/lib/head/HeadTags'

import style from './ErrorComponent.module.scss'

interface Props {
  errorCode?: string
  errorMessage?: string
  reset?: () => void
}

export default memo<Props>(function ErrorComponent({reset, errorCode, errorMessage}) {
  return (
    <div className={style.Page}>
      <HeadTags title='Error' />
      <ErrorBoundary fallback={null}>
        <Navbar withSearch />
      </ErrorBoundary>
      <main>
        <div className={style.NotFound}>
          <img src={errorDecorSvg} className={style.DecorSvg} alt='' />
          <h1 className={style.Heading}>
            We’re not perfect, error happens{errorCode ? `: ${errorCode}` : '!'}
          </h1>
          <span className={style.Description}>{errorMessage}</span>
          <div>
            <PrimaryButton
              onPress={() => {
                if (reset) {
                  reset()
                } else {
                  globalThis.location.reload()
                }
              }}
            >
              Try again
            </PrimaryButton>
          </div>
        </div>
      </main>
    </div>
  )
})
